import _findKey from 'lodash/findKey'
import _omit from 'lodash/omit'
import _ from 'lodash/core'
import _mapValues from 'lodash/mapValues'
import _isObject from 'lodash/isObject'
import _fromPairs from 'lodash/fromPairs'

export const makeCategories = function (data, options) {
  const path = {
    cities: (city) => ({
      path: `${options.baseUrl}${city.friendlyPath ? '/' + city.friendlyPath : ''}`,
      query: this.$route.query,
      params: { listTop: true },
    }),
    subCategories: (category) => ({
      path: `${options.baseUrl}`,
      query: { ...this.$route.query, category: category.id || category.code },
      params: { listTop: true },
    }),
    themes: (theme) => ({
      path:
        theme.id == 'all'
          ? `${this.localePath('/theme')}/${theme.friendlyPath}`
          : `${this.localePath('/theme')}/${theme.friendlyPath}/${theme.id || theme.code}`,
      query: {},
      params: { listTop: true },
    }),
  }

  const makeChild = (obj, key, parent) => {
    let childKey
    const getKey = (key1, key2) => {
      const arr = key1 || key2

      return Array.isArray(arr) ? arr : []
    }

    const data = getKey(obj[key] || parent[key]).map((child) => {
      childKey = _findKey(child, (val) => Array.isArray(val))
      child.friendlyPath = child.friendlyPath || parent.friendlyPath

      return {
        ..._omit(child, [childKey, 'id', 'code']),
        id: child.id || child.code,
        url: !childKey && path[key](child),
        child: childKey ? makeChild(child, childKey, child) : [],
      }
    })

    if (options.useAll && obj[key] && !childKey) {
      if (options.exceptAllId) {
        obj.id = 'all'
      }
      data.unshift({
        id: options.exceptAllId ? parent.friendlyPath : obj.id || obj.code,
        name: this.$t('common.categories.all'),
        url: path[key] && path[key](obj),
      })
    }
    return data
  }

  return _(data).map(makeChild).flatten().value()
}

export const setCookie = function (name, value, exp = 30, domain = '') {
  let str = `${name}=${value};path=/`
  if (exp) {
    const date = new Date()
    date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000)
    str = str.concat(`;expires=${date.toUTCString()}`)
  }
  if (domain) {
    str = str.concat(`;domain=${domain}`)
  }
  document.cookie = str
}

export const getCookie = function (name, cookie = document.cookie) {
  const value = cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return value && value[2] ? value[2] : null
}

export const delCookie = function (name, domain) {
  document.cookie =
    name +
    '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; ' +
    (domain ? ` domain=${domain}` : '')
}

export const encodeQuery = function (queryData) {
  return _mapValues(queryData, (data, key, obj) => {
    if (Array.isArray(data)) {
      return data.join()
    } else if (_isObject(data)) {
      return Object.keys(data)
        .map((k, idx) => `${k}^${data[idx]}`)
        .join()
    } else {
      return data
    }
  })
}

export const decodeQuery = function (queryData) {
  return _mapValues(queryData, (query) => {
    if (query.includes('^')) {
      return _fromPairs(query.split(',').map((item) => [...item.split('^')]))
    } else {
      return !query ? undefined : query.split(',')
    }
  })
}

// Deep clone
export const cloneDeepObject = function cloneDeepObject(obj) {
  const clone = {}
  for (const i in obj) {
    if (typeof obj[i] === 'object' && obj[i] != null) {
      clone[i] = cloneDeepObject(obj[i])
    } else {
      clone[i] = obj[i]
    }
  }
  return clone
}

export const _property = function (path) {
  const shallowProperty = (key) =>
    function (obj) {
      return obj == null ? void 0 : obj[key]
    }
  const deepGet = (obj, path) => {
    const length = path.length
    for (let i = 0; i < length; i++) {
      if (obj == null) {
        return void 0
      }
      obj = obj[path[i]]
    }
    return length ? obj : void 0
  }

  if (!Array.isArray(path)) {
    return shallowProperty(path)
  }
  return (obj) => deepGet(obj, path)
}
